import { createVNode as _createVNode } from "vue";
import { defineComponent, h, resolveComponent } from 'vue';
import Abstract, { useStyleConfig } from '../abstract';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons-vue';
import { Dropdown, Menu } from 'ant-design-vue';
import { Colors } from '../utils';
import { useResizeObserver } from '@vueuse/core';
var MenuItem = Menu.Item,
  MenuDivider = Menu.Divider;
export var StepinHeaderAction = defineComponent({
  name: 'StepinHeaderAction',
  setup: function setup(props, ctx) {
    var _useStyleConfig = useStyleConfig('header-action'),
      prefixCls = _useStyleConfig.prefixCls;
    return function () {
      var _ctx$slots;
      return _createVNode("div", {
        "class": "".concat(prefixCls.value)
      }, [(_ctx$slots = ctx.slots) === null || _ctx$slots === void 0 ? void 0 : _ctx$slots.default()]);
    };
  }
});
var StepinHeader = defineComponent({
  name: 'StepinHeader',
  extends: Abstract,
  components: {
    MenuFoldOutlined: MenuFoldOutlined,
    MenuUnfoldOutlined: MenuUnfoldOutlined
  },
  props: {
    collapsed: {
      type: Boolean,
      default: undefined
    },
    avatar: {
      type: String,
      default: 'https://gw.alipayobjects.com/zos/rmsportal/WhxKECPNujWoWEFNdnJE.png'
    },
    username: String,
    userMenuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showTrigger: Boolean,
    mode: String
  },
  emits: ['update:collapsed'],
  data: function data() {
    return {
      className: 'header',
      sCollapsed: false,
      mainWidth: 'unset'
    };
  },
  computed: {
    bindCollapsed: {
      get: function get() {
        var _this$collapsed;
        return (_this$collapsed = this.collapsed) !== null && _this$collapsed !== void 0 ? _this$collapsed : this.sCollapsed;
      },
      set: function set(val) {
        this.sCollapsed = val;
        this.$emit('update:collapsed', !this.collapsed);
      }
    },
    sTheme: function sTheme() {
      var configProvider = this.configProvider;
      var bgHeader = configProvider.theme.color.middle['bg-header'];
      return Colors.isDarkColor(bgHeader) ? 'dark' : 'light';
    }
  },
  methods: {
    toggle: function toggle() {
      this.bindCollapsed = !this.bindCollapsed;
    }
  },
  mounted: function mounted() {
    var _this = this;
    useResizeObserver([this.$refs.header, this.$refs.left, this.$refs.right], function () {
      var _this$$refs = _this.$refs,
        header = _this$$refs.header,
        left = _this$$refs.left,
        right = _this$$refs.right;
      var _getComputedStyle = getComputedStyle(header),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;
      var pLeft = Number(paddingLeft.replace('px', ''));
      var pRight = Number(paddingLeft.replace('px', ''));
      _this.mainWidth = header.clientWidth - left.clientWidth - right.clientWidth - pLeft - pRight + 'px';
    });
  },
  render: function render() {
    var prefixCls = this.prefixCls,
      toggle = this.toggle,
      bindCollapsed = this.bindCollapsed,
      username = this.username,
      avatar = this.avatar,
      slots = this.$slots,
      userMenuList = this.userMenuList,
      showTrigger = this.showTrigger,
      sTheme = this.sTheme;
    var collapsedIcon = bindCollapsed ? MenuFoldOutlined : MenuUnfoldOutlined;
    var actions = slots !== null && slots !== void 0 && slots.actions ? slots === null || slots === void 0 ? void 0 : slots.actions() : [];
    var menuList = userMenuList.map(function (item) {
      var title = item.title,
        icon = item.icon,
        key = item.key,
        _item$type = item.type,
        type = _item$type === void 0 ? 'item' : _item$type;
      if (type === 'divider') {
        return h(MenuDivider);
      } else {
        var Icon = typeof icon === 'string' ? h(resolveComponent(icon)) : icon;
        return h(MenuItem, {
          key: key
        }, function () {
          return [Icon, " ".concat(title)];
        });
      }
    });
    var userMenuClick = function userMenuClick(event) {
      var _userMenuList$find;
      return (_userMenuList$find = userMenuList.find(function (item) {
        return item.key === event.key;
      })) === null || _userMenuList$find === void 0 ? void 0 : _userMenuList$find.onClick(event);
    };
    var avatarMenu = menuList.length > 0 ? h(Menu, {
      class: "".concat(prefixCls, "-avatar-menu"),
      onClick: userMenuClick
    }, function () {
      return menuList;
    }) : null;
    return _createVNode("div", {
      "ref": 'header',
      "class": ["".concat(prefixCls), sTheme]
    }, [_createVNode("div", {
      "ref": 'left',
      "class": "".concat(prefixCls, "-left")
    }, [slots !== null && slots !== void 0 && slots.logo ? slots === null || slots === void 0 ? void 0 : slots.logo() : null, _createVNode("div", {
      "class": ['trigger', {
        invisible: !showTrigger
      }],
      "onClick": toggle
    }, [h(collapsedIcon, {
      class: 'collapsed-icon'
    })])]), _createVNode("div", {
      "style": "width: ".concat(slots !== null && slots !== void 0 && slots.content ? this.mainWidth : 'unset', ";"),
      "class": "".concat(prefixCls, "-main")
    }, [slots !== null && slots !== void 0 && slots.content ? slots === null || slots === void 0 ? void 0 : slots.content() : null]), _createVNode("div", {
      "ref": 'right',
      "class": "".concat(prefixCls, "-right")
    }, [actions, h(Dropdown, {
      placement: 'bottomRight',
      overlay: avatarMenu
    }, function () {
      return _createVNode("div", {
        "class": ['personal', "".concat(prefixCls, "-action")]
      }, [_createVNode("img", {
        "class": 'avatar',
        "src": avatar
      }, null), _createVNode("span", {
        "class": 'username'
      }, [username])]);
    })])]);
  }
});
export default StepinHeader;